module.exports = __webpack_public_path__ + "img/分区03.f23e3def.png";